var _defs, _path, _polygon, _circle, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconReports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.83 21.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#343434;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m13.03,10.7h6.4c1.33,0,2.4,1.07,2.4,2.4v6.4c0,1.33-1.07,2.4-2.4,2.4h-6.4c-1.33,0-2.4-1.07-2.4-2.4v-6.4c0-1.33,1.07-2.4,2.4-2.4Zm-.8,8.8c0,.44.36.8.8.8h6.4c.44,0,.8-.36.8-.8v-6.4c0-.44-.36-.8-.8-.8h-6.4c-.44,0-.8.36-.8.8v6.4Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "14.37 15.22 15.66 16.52 15.66 13.92 16.8 13.92 16.8 16.52 18.1 15.22 18.9 16.02 16.23 18.69 13.56 16.02 14.37 15.22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.93,
    cy: 5.67,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.93,
    cy: 14.33,
    r: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.93,
    cy: 10,
    r: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m14.89,0H5C2.24,0,0,2.24,0,5v10c0,2.76,2.24,5,5,5h5.68c-.03-.16-.05-.33-.05-.5v-1.5h-5.63c-1.66,0-3-1.34-3-3V5c0-1.66,1.34-3,3-3h8.56v4.44h4.44v4.26h1.43c.2,0,.39.03.57.07v-5.67L14.89,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconReports);
export default __webpack_public_path__ + "static/media/navigation-icon-reports.1d19b475cdcdfc6bc73d0a07782a9683.svg";
export { ForwardRef as ReactComponent };